import React from 'react';
import styles from './styles.module.scss';
import icCloseIcon from 'assets/svg/ic_close_2.svg';
import icConnectWallet from 'assets/svg/ic_connect_wallet_2.svg';
import Modal from '@profile/src/Components/Modal';
import Button from '@profile/src/Components/Button_V2';

const ConnectWalletModal = ({
  onClose,
  onConnectButtonPressed
}) => {
  return /*#__PURE__*/React.createElement(Modal, null, /*#__PURE__*/React.createElement("div", {
    className: styles.modal
  }, /*#__PURE__*/React.createElement("button", {
    className: styles.close,
    onClick: onClose
  }, /*#__PURE__*/React.createElement("img", {
    src: icCloseIcon
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.iconContainer
  }, /*#__PURE__*/React.createElement("img", {
    src: icConnectWallet
  })), /*#__PURE__*/React.createElement("span", {
    className: styles.title
  }, "Connect Wallet"), /*#__PURE__*/React.createElement("span", {
    className: styles.description
  }, "You need to connect your wallet first"), /*#__PURE__*/React.createElement("div", {
    className: styles.buttonGroup
  }, /*#__PURE__*/React.createElement(Button, {
    title: "Cancel",
    type: "secondary",
    onClick: onClose
  }), /*#__PURE__*/React.createElement(Button, {
    title: "Connect",
    onClick: onConnectButtonPressed
  }))));
};

export default ConnectWalletModal;